import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosHeadOffice';

export const GetReportLinks = createAsyncThunk(
  '/GetReportLinks',
  async () => {
    const response = await axios.get('/GetReportLinks');
    return response.data;
  }
);

const GeneralReportSlice = createSlice({
  name: 'generalReport',
  initialState: {
    loading: false,
    error: '',
    GeneralReports: [],
    response: ''
  },
  reducers: {
  },
  extraReducers: {
    [GetReportLinks.pending]: (state) => {
      state.loading = true;
    },
    [GetReportLinks.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [GetReportLinks.fulfilled]: (state, action) => {
      state.consumerAdressTypes = action.payload;
      state.loading = false;
    }
  }
});

export const generalReportActions = GeneralReportSlice.actions;

export default GeneralReportSlice;
